import PropTypes from 'prop-types';
import { baseFieldClasses } from '../../../form/Input';

const DateInput = ({ value, onChange, ...props }) => (
    <input
        type="datetime-local"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`${baseFieldClasses} px-3 py-2`}
        {...props}
    />
);

DateInput.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

const DateRangePicker = ({ startDate, endDate, onStartDateChange, onEndDateChange }) => (
    <div className="flex items-center space-x-4">
        <div className="flex-1">
            <DateInput
                value={startDate}
                onChange={onStartDateChange}
                aria-label={gettext('FILTER_START_DATE')}
            />
        </div>
        <span className="mx-2"> - </span>
        <div className="flex-1">
            <DateInput
                value={endDate}
                onChange={onEndDateChange}
                aria-label={gettext('FILTER_END_DATE')}
            />
        </div>
    </div>
);

DateRangePicker.propTypes = {
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    onStartDateChange: PropTypes.func.isRequired,
    onEndDateChange: PropTypes.func.isRequired,
};

export default DateRangePicker;
